import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_verifone_point_sca_event.js";
//#region src/bite_log_verifone_point_sca_event_helper.ts
var bite_log_verifone_point_sca_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "success";
		case 2: return "terminal-restarted";
		case 3: return "sale-transaction";
		case 4: return "sale-transaction-error";
		case 5: return "authentication-error";
		case 6: return "port-error";
		case 7: return "sync-time-error";
		case 8: return "key-store-error";
		case 9: return "terminal-disconnected";
		case 10: return "capture-timeout-recovery";
		case 11: return "capture-timeout-gateway-stuck";
		case 12: return "capture-timeout-session-cleanup-failed";
		case 13: return "capture-timeout-payment-recovered";
		case 14: return "start-session-busy-recovery";
	}
}
//#endregion
export { bite_log_verifone_point_sca_event_helper_exports, name };

//# sourceMappingURL=bite_log_verifone_point_sca_event_helper.js.map